var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qr-code',{attrs:{"text":"https://www.thefixit.net/fixit.vcf","size":"250","color":"#000","bg-color":"#fff","error-level":"L"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }